import type { TechniqueEntry } from '../schema';

// review: candidate draft grounded in the NIAAA CBI manual — no shipped delivery prose in the
// repo; needs genuine clinical origination review, not just sign-off.
export const socialMoments: TechniqueEntry = {
  key: 'social_moments',
  version: '0.1-candidate',
  name: 'Social moments',
  pillar: 'CBT',
  serves:
    'Navigating drinking or using situations with other people present (pressure real or perceived, the empty hand, the first-hour pull), with moves sized to what the member actually faces.',
  method: [
    'Locate the specific recurring social pattern (the Friday team drinks, the family dinner, the yearly barbecue).',
    'Separate the two pressures the manual distinguishes: indirect (just being around people drinking tempts, even with no offer made) and direct (offers, encouragement, cajoling, shaming). Both are real; work the one the member actually faces.',
    "Surface the thoughts that make refusing hard (the manual's list: fear of looking weak or boring, the sense that it is not right to refuse when everyone is sharing the occasion, the worry of imposing by being assertive) and the framing shift underneath: an I-can't-drink framing breeds what the manual calls cognitive claustrophobia; an I-choose-not-to framing does not.",
    'Then offer moves as options to react to, two or three at a time, never the full menu (the standing guideline caps any list at three): from avoid the avoidable (legitimate, especially early: the manual treats avoiding unnecessary high-risk situations as what successful quitters actually do), an escape plan left open for when temptation runs too strong, sober support brought along, a drink always in hand, arrive late or leave early, one rehearsed line.',
    'Ask what feels closest, and let them pick what fits their room. When a line is chosen, pair with behavioural rehearsal.',
  ],
  never: [
    'Never imply their social world must change first.',
    'Never dismiss perceived pressure: indirect pressure is a manual-recognised category, and the perceived kind is testable (the experiment framing), not imaginary.',
    "Never hand them a script they didn't shape.",
    'Never frame avoidance as weakness: the manual treats it as the successful early strategy.',
  ],
  requiresFirst: [
    {
      kind: 'conversation',
      clause: 'A named, recurring social situation.',
    },
  ],
  doneWhen:
    'The member has chosen one move for one named situation and can say how they will use it.',
  firstMove: null,
  exemplars: [],
  appliesTo: ['base', 'journey'],
  programs: null,
  signature: null,
  source:
    'NIAAA CBI manual §5.4 DREF (pp. 149–160 — indirect/direct pressure, refusal cognitions, coping strategies); catalog #15 / #19 / #44 / #45 cluster; intake preview naming (handling social moments). No shipped prose in our repo.',
};
